import {
  Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  CreateModalSuccessBox,
  DescriptionTypography,
  TextContent,
  TitleTypography
} from "./CreateModalSuccess.styles";
import { CreateModalSuccessProps } from "./CreateModalSuccess.types";
import { ButtonText, Icon } from "../../components";

export function CreateModalSuccess({
  onClose,
  ...props
}: CreateModalSuccessProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement | null>(null);


  useEffect(() => {
    if (props.title ) {
      titleRef.current?.focus();
    }
  }, [props.title ]);

  return (

    <CreateModalSuccessBox
      role="dialog"
      aria-modal="true"
      aria-labelledby="success-title"
      container
      { ...props }
    >
      <Icon
        tabIndex={ 0 }
        aria-label={ t("close") }
        icon={ "close" }
        size={ "24px" }
        cursor="pointer"
        color={ theme.palette.primary?.main }
        transform= "rotate(-90deg)"
        onKeyDown={ (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if(onClose){
              onClose();
            }
          }
        } }
        onClick={ ()=> {
          if(onClose){
            onClose();
          }
        }
        }
      />
      <TextContent>
        <TitleTypography  
          ref={ titleRef }
          tabIndex={ -1 } 
          id="success-title">
          {  props.title }
        </TitleTypography>
        <DescriptionTypography>
          { t("give_voice") }
        </DescriptionTypography>
        <Stack
          flexDirection="row"
          gap={ theme.spacing(1) }
          justifyContent={ "center" }
          marginTop={ "16px" }
        >
          <ButtonText
            sx={ {
              borderRadius:"2px",
              fontWeight:700,
              maxWidth:"120px",
              padding:theme.spacing(1,2)
            } }
            onClick={ ()=> {
              if(onClose){
                onClose();
              }

            } }
          >
            { t("continue") }
          </ButtonText>
        </Stack>
      </TextContent>
    </CreateModalSuccessBox>

  );
}
